/* sk-snacks-hero — 4D animated hero
   Builds the floating "sprinkle" confetti layer, runs cursor parallax,
   and replays the entrance animation when the hero scrolls into view.
   Ported from the Claude Design "Snacks Hero 4D" export. */
(function () {
  var COLS = ['#A8C13C', '#f16722', '#E8B53A', '#8AA22E', '#c94e12'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buildSprinkles(hero, layer, count) {
    // seeded PRNG so the burst looks the same on every load (matches the export)
    var seed = 11;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }

    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.className = 'sk-snacks-hero__sprinkle' + (rnd() < 0.3 ? ' is-dot' : '');
      var side = i % 2 === 0 ? -1 : 1;
      s.style.setProperty('--tx', (side * (24 + rnd() * 22)).toFixed(1) + 'vw');
      s.style.setProperty('--ty', (-26 + rnd() * 56).toFixed(1) + 'vh');
      s.style.setProperty('--rot', Math.round(-70 + rnd() * 140) + 'deg');
      s.style.setProperty('--d', (0.85 + rnd() * 0.5).toFixed(2) + 's');
      s.style.setProperty('--fdur', (2.4 + rnd() * 2).toFixed(2) + 's');
      s.style.setProperty('--fdel', (-rnd() * 3).toFixed(2) + 's');
      s.style.setProperty('--z', (0.25 + rnd() * 0.75).toFixed(2));

      var px = document.createElement('span');
      px.className = 'sk-snacks-hero__px';
      var bar = document.createElement('i');
      bar.className = 'sk-snacks-hero__bar';
      bar.style.setProperty('--col', COLS[i % COLS.length]);
      px.appendChild(bar);
      s.appendChild(px);
      layer.appendChild(s);
    }
  }

  function initParallax(hero, layer) {
    var raf = null;
    hero.addEventListener('mousemove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var r = hero.getBoundingClientRect();
        layer.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * 64).toFixed(1));
        layer.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * 48).toFixed(1));
      });
    });
    hero.addEventListener('mouseleave', function () {
      layer.style.setProperty('--mx', 0);
      layer.style.setProperty('--my', 0);
    });
  }

  function reveal(hero) { hero.classList.add('is-in'); }

  function initReveal(hero) {
    if (!('IntersectionObserver' in window)) { reveal(hero); return; }
    // Play the entrance exactly once when the hero first enters view, then stop
    // observing. No removing `is-in` — toggling it (e.g. on a web-font layout
    // shift) is what made the animation flash and restart.
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(hero); obs.disconnect(); }
      });
    }, { threshold: 0.15 });
    obs.observe(hero);
  }

  function init(hero) {
    if (hero.dataset.skHeroReady) return;
    hero.dataset.skHeroReady = '1';

    var layer = hero.querySelector('.sk-snacks-hero__sprinkles');
    var count = parseInt(hero.getAttribute('data-sprinkles'), 10);
    if (isNaN(count)) count = 26;

    if (layer && count > 0 && !reduce) {
      buildSprinkles(hero, layer, count);
      initParallax(hero, layer);
    }
    initReveal(hero);
  }

  function boot() {
    document.querySelectorAll('[data-sk-snacks-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-sk-snacks-hero]');
    if (hero) init(hero);
  });
})();
